import angular from 'angular';
import emailTemplates from './emailTemplates';

export default angular
  .module('components.emailTemplates', [])
  .component('emailTemplates', emailTemplates).name;
